import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Modal } from 'react-bootstrap';
import LoadingComponent from '../../common/LoadingComponent';
import { deletePlaceRequested } from './redux/actions';
import { getDeletePlaceLoading } from './redux/selectors';
import './styles.scss';

function PlaceDelete({ show, loading, onClose, placeId, deletePlace }) {
    useEffect(() => {
        if (!loading) {
            onClose();
        }
    }, [loading]);

    const loader = <LoadingComponent isLoading={loading} />;
    return (
        <div>
            <Modal
                onHide={() => {
                    onClose();
                }}
                backdrop="static"
                show={show}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                className="place-delete-modal"
                centered={true}
                animation={true}
            >
                {loading && loader}
                <label>Are you sure you want to delete this record?</label>
                <div className="footer">
                    <button
                        onClick={() => deletePlace(placeId)}
                        className="save-btn"
                    >
                        Delete
                    </button>
                    <button onClick={onClose} className="cancel-btn">
                        Cancel
                    </button>
                </div>
            </Modal>
        </div>
    );
}

PlaceDelete.propTypes = {
    show: PropTypes.bool,
    placeId: PropTypes.number,
    loading: PropTypes.bool,
    onClose: PropTypes.func,
    deletePlace: PropTypes.func,
};

PlaceDelete.defaultProps = {
    show: false,
    placeId: null,
    loading: false,
};

const mapStateToProps = (state) => {
    return {
        loading: getDeletePlaceLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        deletePlace: (placeId) => dispatch(deletePlaceRequested(placeId)),
    };
};

const ConnectedPlaceDelete = connect(
    mapStateToProps,
    mapDispatchToProps,
)(PlaceDelete);

export default ConnectedPlaceDelete;
